import { brand } from '../brand';
import pitpayLogo from './assets/pitpay-logo.png';
import tickethossLogo from './assets/tickethoss-logo.png';

// The logo header on single-entry downloads and the submissions report
// (Implementation List §2): the account's logo (or a monogram tile) and
// name on the left, "Powered by" + the platform's logo on the right.

// Two words → first letter of each; one word of 4 letters or fewer → the
// whole word; otherwise its first two letters.
export const monogram = (name) => {
  const words = String(name || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (!words.length) return '?';
  if (words.length === 1) {
    const [word] = words;
    return (word.length <= 4 ? word : word.slice(0, 2)).toUpperCase();
  }
  return (words[0][0] + words[1][0]).toUpperCase();
};

// Print windows and spreadsheets need absolute image URLs.
export const absoluteUrl = (src) => {
  if (!src) return null;
  try {
    return new URL(src, document.baseURI).href;
  } catch (e) {
    return src;
  }
};

export const platformLogo = () =>
  absoluteUrl(
    process.env.REACT_APP_PLATFORM === 'tickethoss'
      ? tickethossLogo
      : pitpayLogo
  );

// account = the form's { id, name, logo }.
export const brandInfo = (account) => {
  const name = (account && account.name) || '';
  return {
    name,
    logo: (account && account.logo) || null,
    mono: monogram(name),
    platform: brand().name,
    platformLogo: platformLogo(),
  };
};

export default brandInfo;
